import React, { Component } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import { logout } from '../../utils';

class AccountMenu extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    handleLogout(){
        logout();
        this.props.history.push('/');
    }

    render() {
        const profileName = localStorage.getItem('BYOS_UserName');
        const profileInitials = profileName
            ? profileName.split(/\s+/).slice(0, 2).map((part)=>part.charAt(0)).join('').toUpperCase()
            : 'NA';
        return (
            <aside className="account-side">
                    <div className="account-side__profile">
                        <div className="account-side__avatar">{profileInitials}</div>
                        <div className="account-side__profileCopy">
                            <span>Natureway account</span>
                            <strong>{profileName || 'Profile'}</strong>
                        </div>
                    </div>

                <nav className="account-side__nav" aria-label="Account navigation">
                    <div className="account-side__group">
                        <span className="account-side__groupLabel">Account</span>
                        <NavLink
                            exact
                            to="/account"
                            className="account-side__link"
                            activeClassName="account-side__link--active"
                        >
                            <i className="icon-user"></i>
                            <span>Profile Information</span>
                        </NavLink>
                        <NavLink
                            to="/address"
                            className="account-side__link"
                            activeClassName="account-side__link--active"
                        >
                            <i className="icon-map-marker"></i>
                            <span>Manage Addresses</span>
                        </NavLink>
                    </div>

                    <div className="account-side__group">
                        <span className="account-side__groupLabel">Orders</span>
                        <NavLink
                            to="/orders"
                            className="account-side__link"
                            activeClassName="account-side__link--active"
                        >
                            <i className="icon-bag2"></i>
                            <span>Orders</span>
                        </NavLink>
                        <NavLink
                            to="/wishlist"
                            className="account-side__link"
                            activeClassName="account-side__link--active"
                        >
                            <i className="icon-heart"></i>
                            <span>My Wishlist</span>
                        </NavLink>
                        <NavLink
                            to="/reviews"
                            className="account-side__link"
                            activeClassName="account-side__link--active"
                        >
                            <i className="icon-star"></i>
                            <span>My Reviews & Ratings</span>
                        </NavLink>
                    </div>

                    <button
                        type="button"
                        className="account-side__logout"
                        onClick={() => this.handleLogout()}
                    >
                        <i className="icon-power"></i>
                        <span>Logout</span>
                    </button>
                </nav>
            </aside>
        );
    }
}

export default withRouter(AccountMenu);
